module.exports = __webpack_public_path__ + "img/bicycle-purple.742112e1.svg";